// tr("English text") → the same text in the member's language.
//
// • The key is the English text exactly as written in the code, so a screen
//   always reads correctly even if a line hasn't been translated yet.
// • Values are filled in with %@ in order (or %1$@, %2$@ when a language
//   needs a different word order): tr("%@ new messages", count).
// • %% is a literal % in text that has values.
// • The table for the chosen language is loaded once, before the app starts
//   (see main.js). Changing language reloads the page, so every label —
//   including ones built in data() or at the top of a file — switches together.
let table = {};
let loaded = "en";

export async function loadLanguageTable(code) {
  if (!code || code === "en") { table = {}; loaded = "en"; return; }
  try {
    const mod = await import(/* webpackChunkName: "lang-[request]" */ `./tables/${code}.js`);
    table = mod.default || {};
    loaded = code;
  } catch (e) {
    console.warn("Couldn't load the " + code + " text; showing English.", e);
    table = {};
    loaded = "en";
  }
}

export function loadedLanguage() {
  return loaded;
}

export function tr(english, ...args) {
  const text = Object.prototype.hasOwnProperty.call(table, english) ? table[english] : english;
  if (!args.length) return text;
  let next = 0;
  return text.replace(/%(?:(\d+)\$)?@|%%/g, (m, n) => {
    if (m === "%%") return "%";
    const v = n ? args[Number(n) - 1] : args[next++];
    return String(v);
  });
}

export default tr;
